export default "__VITE_ASSET__T46UOmzm__"